/**
 * @generated SignedSource<<28681b5835b8db2bb6d9795cd30b1214>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
export type VisibilityTreeConfigType = "VisibilityTree_AfterDateTime" | "VisibilityTree_Hide" | "VisibilityTree_HideForFachberater" | "VisibilityTree_NotAfterDateTime" | "VisibilityTree_OnlyAdmins" | "VisibilityTree_OnlyBasicSeminar" | "VisibilityTree_OnlyFachberater" | "VisibilityTree_OnlyFachrichtungen" | "VisibilityTree_OnlyIfTreeState" | "VisibilityTree_OnlyIfTreeStateOrAdmin" | "VisibilityTree_OnlySpecificPermissions" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type RootNodesTable_TreeNodeFragment$data = {
  readonly structureDefinition: {
    readonly extension?: {
      readonly configConsequences?: {
        readonly rewardExpired: boolean;
      };
    };
    readonly visibilityConfigs?: ReadonlyArray<{
      readonly configType: VisibilityTreeConfigType;
      readonly dateTime?: string;
      readonly id?: string;
    }>;
  };
  readonly " $fragmentSpreads": FragmentRefs<"ActionColumn_TreeNodeFragment" | "ConfigurationBadgesColumn_TreeNodeFragment" | "ContentColumn_TreeNodeFragment" | "IsRewardedToColumn_TreeNodeFragment" | "ReleasedAtColumn_TreeNodeFragment" | "TagsColumn_TreeNodeFragment" | "TitleColumn_TreeNodeFragment">;
  readonly " $fragmentType": "RootNodesTable_TreeNodeFragment";
};
export type RootNodesTable_TreeNodeFragment$key = {
  readonly " $data"?: RootNodesTable_TreeNodeFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"RootNodesTable_TreeNodeFragment">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "RootNodesTable_TreeNodeFragment"
};

(node as any).hash = "0ff2e972d97f9192bac294768779e7cb";

export default node;
